import React, { FC, ReactElement, useEffect, useState } from 'react'
import * as d3 from 'd3'
import styled from 'styled-components'
import { ArrowIcon } from 'Assets/Arrow'
import { SortDown } from 'Assets/SortDown'
import { SortUp } from 'Assets/SortUp'
import { Municipality } from 'Types/Municipality'
export interface Props {
  /** The actual data to color the map. Each object must contain the property Rank! (e.g. [{bfsId: 261, Rank: "7"},...]) */
  municipalityData: Municipality[]
  colorPalette: [string, string, string]
  minValue: number
  maxValue: number
  activeMunicipalityId?: number
  onSelectionHandler: (selectedId: number) => void
  locale: 'de' | 'fr'
}

export const RankingTable: FC<Props> = ({
  municipalityData,
  colorPalette,
  minValue,
  maxValue,
  onSelectionHandler,
  activeMunicipalityId,
  locale,
}): ReactElement => {
  // useEffect(()=>{},[municipalityData])
  const [showCount, setShowCount] = useState(10)
  const [reversed, setReversed] = useState(false)
  const color = d3
    .scaleLinear<string>()
    .domain([minValue, (minValue + maxValue) / 2, maxValue])
    .range(colorPalette || ['green', 'lightgrey', 'red'])

  return (
    <Ranking className='ui graphic container list' id='ranking'>
      <h4 id='ranking-title'>
        {locale === 'fr'
          ? 'Les ' + (reversed ? 'plus chères ' : 'moins chères ')
          : 'Die ' + (reversed ? 'teuersten ' : 'günstigsten ')}
        {showCount}
      </h4>
      <table
        id='ranking-table'
        className='ui small unstackable selectable table'
      >
        <thead>
          <tr>
            <th />
            <th>{locale === 'fr' ? 'Commune' : 'Gemeinde'}</th>
            <th>{locale === 'fr' ? 'Canton' : 'Kanton'}</th>
            <th className='right aligned'>
              {locale === 'fr' ? 'Charge' : 'Belastung'}
            </th>
          </tr>
        </thead>
        <tbody>
          {municipalityData
            .sort((muniA, muniB) =>
              reversed ? muniB.rank - muniA.rank : muniA.rank - muniB.rank
            )
            .slice(0, showCount)
            .map((municipality) => {
              return (
              <tr
                key={municipality.bfsId}
                onClick={() => {
                  onSelectionHandler(municipality.bfsId)
                }}
                className={
                  activeMunicipalityId &&
                  +activeMunicipalityId === municipality.bfsId
                    ? 'selected'
                    : ''
                }
              >
                <td
                  className='center aligned rank'
                  style={{ backgroundColor: color(municipality.taxloadrelative) }}
                >
                  {municipality.rank}
                </td>
                <td className='municipality-name'>
                  <div className='municipality-name-wrapper'>
                    {municipality?.[("name_" + locale) as "name_de" | "name_fr"]}
                  </div>
                </td>
                <td>{municipality.canton}</td>
                <td className='right aligned'>
                  {municipality.taxloadrelative?.toFixed(2).replace(".",",")}%
                </td>
              </tr>
            )})}
        </tbody>
      </table>
      <ButtonsWrapper>
        <Button
          className='ui button'
          onClick={() => setShowCount(showCount + 20)}
        >
          <ArrowIcon />
          {locale === 'fr' ? ' Afficher 20 communes de plus' : 'Mehr anzeigen'}
        </Button>
        <Button className='ui button' onClick={() => setReversed(!reversed)}>
          {reversed ? <SortDown /> : <SortUp />}
          {locale === 'fr' ? ' Inverser le tri' : ' Reihenfolge umkehren'}
        </Button>
      </ButtonsWrapper>
    </Ranking>
  )
}
const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  align-items: flex-start;
  margin-top: 1rem;
`
const Button = styled.button`
  // reset button styles
  color: var( --button-color);
  display: flex;
  align-items:center;
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  svg{
    margin-right:.3em;
    width:1.2em;
  }
`
const Ranking = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 600px;
  margin: 0 auto;
  h4#ranking-title {
    font-size: 1.4em;
    @media only screen and (max-width: 600px) {
      font-size: 1.2em;
    }
    font-weight: 600;
    line-height: 1.15em;
    text-align: center;
    font-family: var(--chart-font-stack);
    
    margin-bottom: 1em;
  }

  #ranking-table.ui.selectable.table {
    font-size: 0.9em;
    border-collapse: collapse;
    th {
      font-weight: 700;
      text-align: left;
    }
    .right.aligned {
      text-align: right;
      padding-right: 0.5em;
    }

    tbody tr {
      /* background-color: var(--table-background); */
    }
    tbody tr:hover {
      background-color: #f8f7f4 !important;
    }
    tr {
      cursor: pointer;
      border-bottom: 0.5px solid #78787878;
      td {
        padding: 0.5em 0;
      }
      .rank {
        padding-left: 0.3em;
        padding-right: 0.3em;
        text-align: center;
        color: white;
        min-width: 2em;
      }
      .municipality-name {
        padding-left: 0.5em;
        max-width: 120px;
      }
    }
    .selected {
      font-weight: bold;
    }
  }
`
